import { ProtectedResourceScopes } from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  Configuration,
  LogLevel,
} from '@azure/msal-browser';

import { environment } from '../environments/environment';

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.azureADB2C.clientId,
    authority: environment.azureADB2C.userFlow.authority,
    knownAuthorities: [environment.azureADB2C.authorityDomain],
    redirectUri: '/',
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean
      ): void => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
      logLevel: environment.browserLogging ? LogLevel.Verbose : LogLevel.Error,
      piiLoggingEnabled: false,
    },
  },
};

export const protectedResources = new Map<
  string,
  (string | ProtectedResourceScopes)[]
>([
  [
    `${environment.api.rootUrl}/compensation-api/practice/rdata/list`,
    [`${environment.azureADB2C.apiPermissionRootUrl}/api.read`],
  ],
  [
    `${environment.api.rootUrl}/compensation-api/practice/rdata/aggregates`,
    [`${environment.azureADB2C.apiPermissionRootUrl}/api.read`],
  ],
  [
    `${environment.api.rootUrl}/compensation-api/practice/rdata/*`,
    [`${environment.azureADB2C.apiPermissionRootUrl}/api.read`],
  ],
  [
    `${environment.api.rootUrl}/user-profile-api/practice/practice`,
    [`${environment.azureADB2C.apiPermissionRootUrl}/api.read`],
  ],
  [
    `${environment.api.rootUrl}/compensation-api/rdata/aggregates/specialties`,
    [`${environment.azureADB2C.apiPermissionRootUrl}/api.read`],
  ],
]);
